/* Reverse redirect: /seo/content-studio* -> /social/content-studio* .
 *
 * The AI Content Studio (Blog Creation) surface briefly lived under the SEO
 * engine (Lane E). That move has been reverted: the surface is back under the
 * Content engine at /social/content-studio*. Page components are unchanged;
 * only the SURFACING (route path + nav placement + engine association) moved.
 *
 * SEO-era deep links / bookmarks (`/seo/content-studio[/...]`) existed for a
 * short window and must not 404, so every SEO-era path maps back to its
 * canonical /social home while preserving the trailing segment (`prompt`,
 * `stock`, the numeric `:id`) and any query/hash. The Aura-returned `edit_url`
 * (`/social/content-studio/{id}`, produced backend-side) now resolves natively
 * again.
 *
 * Kept dependency-free + DOM-free so it unit-tests directly under
 * `node --test --experimental-strip-types` with no `@/` resolver hook. */

export const LEGACY_SEO_CONTENT_STUDIO_BASE = '/seo/content-studio';
export const CONTENT_STUDIO_BASE = '/social/content-studio';

/**
 * Map a SEO-era `/seo/content-studio[/...]` pathname back to its canonical
 * `/social` home, preserving any trailing segment. Returns `null` when
 * `pathname` is not a SEO-era content-studio path (caller decides the fallback).
 */
export function mapSeoContentStudioPath(pathname: string): string | null {
  if (pathname === LEGACY_SEO_CONTENT_STUDIO_BASE) return CONTENT_STUDIO_BASE;
  if (pathname.startsWith(LEGACY_SEO_CONTENT_STUDIO_BASE + '/')) {
    return CONTENT_STUDIO_BASE + pathname.slice(LEGACY_SEO_CONTENT_STUDIO_BASE.length);
  }
  return null;
}
